var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, useEffect } from 'react';
import { Heading } from '../heading';
import { NotificationIcon } from '../notification-icon';
import { useModal } from './modal-context';
import { avatarStyle, decorativeHeaderStyle, headerStyle } from './styles';
function Header(_a) {
    var { children, customIconOverride, mode = 'plain', variant = 'info' } = _a, restProps = __rest(_a, ["children", "customIconOverride", "mode", "variant"]);
    const { alignCenter, headerId, id, setHasDecorativeHeader, setHeaderId } = useModal();
    useEffect(() => {
        setHeaderId(`${id}-header`);
        setHasDecorativeHeader(mode === 'decorative');
    }, [id, setHeaderId, setHasDecorativeHeader, mode]);
    function renderIcon() {
        return customIconOverride != null ? (
        // Auto-set size of custom icon
        cloneElement(customIconOverride, { size: 'large' })) : (_jsx(NotificationIcon, { size: "large", variant: variant }));
    }
    return (_jsxs(_Fragment, { children: [mode === 'decorative' && (_jsx("div", Object.assign({ css: decorativeHeaderStyle({ variant }) }, { children: _jsx("span", Object.assign({ css: avatarStyle({ variant }) }, { children: renderIcon() })) }))), _jsx(Heading, Object.assign({ as: "h2", css: headerStyle({ alignCenter }), id: headerId, size: "xxlarge" }, restProps, { children: children }))] }));
}
export default Header;
